"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var storage = new _GatewayService["default"]('user-storage-service');

var fetchFromStorage = function fetchFromStorage(userKey, prefix, itemName) {
  var itemKey = "".concat(prefix, "/").concat(itemName);
  return storage.get("storagev3/".concat(userKey, "/").concat(itemKey), {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

var saveToStorage = function saveToStorage(userKey, prefix, itemName, data) {
  var itemKey = "".concat(prefix, "/").concat(itemName);
  return storage.post("storagev3/".concat(userKey, "/").concat(itemKey), data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

var batchSaveToStorage = function batchSaveToStorage(userKey, prefix, data) {
  var payload = Object.entries(data).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        responseKey = _ref2[0],
        responseData = _ref2[1];

    var itemKey = "".concat(prefix, "/").concat(responseKey);
    return [userKey, itemKey, responseData];
  });
  return storage.post("storagev3/batch-post", payload, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};

var fetchFromStorageByPrefix = function fetchFromStorageByPrefix(userKey, prefix) {
  return storage.get("storagev3/all/".concat(userKey, "/").concat(prefix), {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (response) {
    return response.reduce(function (formattedResponse, entry) {
      var itemName = entry.itemKey.replace("".concat(prefix, "/"), '');
      formattedResponse[itemName] = entry.content;
      return formattedResponse;
    }, {});
  });
};

var _default = {
  fetchFromStorage: fetchFromStorage,
  saveToStorage: saveToStorage,
  batchSaveToStorage: batchSaveToStorage,
  fetchFromStorageByPrefix: fetchFromStorageByPrefix
};
exports["default"] = _default;